<script>
import { preventDefault } from 'svelte/legacy';
import {
    fade
} from 'svelte/transition';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import Event from '@cclib/classes/event.js';
import EventGroup from '@cclib/classes/eventGroup.js';
import LanguageSelect from '@app/components/inputs/LanguageSelect.svelte';
import * as m from "@app/paraglide/messages.js";

let eventGroupDefaults = JSON.parse(localStorage.getItem("cc-event-group-defaults")) || {};
let eventGroupType = $state(eventGroupDefaults.eventGroupType || "subtitle"),
    selectedGroups = $state([]),
    displayName = $state(""),
    orderBy = $state("start"),
    //ripple = false,
    language = $state(eventGroupDefaults.language || "en-US"),
    linkedGroupIndex = $state("none"),
    rtl = $state(eventGroupDefaults.rtl),
    gender = "male",
    selectedLanguage = "English - US",
    virtualVoice = "en-US-Wavenet-A";

function mergeEventGroups() {
    let mergedEvents = [];
    let virtualVoiceOptions = {
        virtualVoice: virtualVoice,
        gender: gender,
        selectedLanguage: selectedLanguage
    }

    eventGroupState.filter(group => {
        return selectedGroups.indexOf(group.id) > -1;
    }).forEach(group => {
        mergedEvents = [...mergedEvents, ...group.events]
    });

    if (orderBy === "start") {
        mergedEvents.sort((eventA, eventB) => {
            return eventA.start - eventB.start
        });
    }

    mergedEvents = JSON.parse(JSON.stringify(mergedEvents));
    mergedEvents.forEach((event, i, events) => {
        events[i] = {...(new Event(event))};
    });

    let eventGroupOptions = {
        type: eventGroupType,
        name: displayName,
        language: language,
        linkedGroupIndex: linkedGroupIndex,
        rtl: rtl,
        events: mergedEvents
    }

    // Use push method instead of direct assignment
    eventGroupState.push({...(new EventGroup({
        ...eventGroupOptions,
        ...virtualVoiceOptions
    }))});

    projectState.selected = eventGroupState.length - 1;
    eventGroupState[projectState.selected].selected = [0];
    
    insertHistoryAction({
        name: "insert event", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
    
    hideModal();
}
</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'mergeEventGroup' ? 'show d-block' : ''}" 
    role="dialog"
    aria-labelledby="mergeEventTitle"
    aria-describedby="mergeEventDesc" 
    tabindex="-1" 
    id="MergeEventGroupModal">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mergeEventTitle">{m.merge_event_group_title()}</h4>
                <button type="button" 
                    class="btn-close" 
                    id="btnCloseMergeEvent"
                    aria-label={m.merge_event_group_close_aria_label()} 
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(mergeEventGroups)}>
                    <!-- Name -->
                    <div class="mb-3"><label class="form-label" for="mergeEventDisplayName"><span class="badge bg-primary">{m.merge_event_group_new_badge()}</span> {m.merge_event_group_display_name_label()}</label>
                        <input class="form-control" 
                            id="mergeEventDisplayName"
                            required 
                            placeholder={m.merge_event_group_display_name_placeholder()} 
                            type="text" 
                            bind:value={displayName}
                            aria-required="true">
                    </div>
                    <!-- Language -->
                    <div class="mb-3">
                        <label class="form-label" for="mergeEventLanguage">{m.merge_event_group_language_label()}</label>
                        <LanguageSelect id="mergeEventLanguage" bind:value={language} />
                    </div>
                    <!-- RTL -->
                    <div class="form-check form-switch mb-2">
                        <input type="checkbox" 
                            class="form-check-input" 
                            id="mergeEventRtl" 
                            bind:checked={rtl}
                            aria-checked={rtl}>
                        <label class="form-check-label" for="mergeEventRtl">{m.merge_event_group_rtl_label()}</label>
                    </div>
                    <!-- Group Type -->
                    <div class="mb-3">
                        <label class="form-label" for="group type">{m.merge_event_group_group_type_label()}</label>
                        <select class="form-select" bind:value={eventGroupType}>
                            <option value="subtitle">{m.merge_event_group_group_type_subtitle()}</option>
                            {#if authState.ad}
                                <option value="audio description">{m.merge_event_group_group_type_audio_description()}</option>
                            {/if}
                            <option value="transcription">{m.merge_event_group_group_type_transcription()}</option>
                            <option value="translation">{m.merge_event_group_group_type_translation()}</option>
                        </select>
                    </div>
                    <!-- Event Groups -->
                    <div class="mb-3">
                        <label class="form-label" for="exampleFormControlSelect2">{m.merge_event_group_event_groups_label()} <span class="text-danger small">{m.merge_event_group_required_badge()}</span></label>
                        <select multiple class="form-select" bind:value={selectedGroups}>
                            {#each eventGroupState as eventGroup}
                                <option value={eventGroup.id}>{eventGroup.name}</option>
                            {/each}
                        </select>
                    </div>
                    {#if selectedGroups.length < 2}
                    <p transition:fade={{duration: 50 }} class="small text-warning">{m.merge_event_group_minimum_warning()}</p>
                    {/if}
                    <!-- Order By -->
                    <div class="mb-3">
                        <label class="form-label" for="group type">{m.merge_event_group_order_by_label()}</label>
                        <select class="form-select" bind:value={orderBy}>
                            <option value="id">{m.merge_event_group_order_by_id()}</option>
                            <option value="start">{m.merge_event_group_order_by_start()}</option>
                        </select>
                    </div>
                    <!-- Linked Group -->
                    {#if eventGroupType === 'translation'}
                    <div transition:fade={{duration: 100 }}>
                        <hr/>
                        <p class="lead text-warning m-0">{m.merge_event_group_translation_options_label()}</p>
                        <div class="mb-3">
                            <label class="form-label" for="Linked group">{m.merge_event_group_linked_group_label()} <i class="bi bi-info-circle" title={m.merge_event_group_linked_group_tooltip()}></i></label>
                            <select class="form-select"  bind:value={linkedGroupIndex}>
                                {#each eventGroupState as eventGroup, index(index)}
                                <option value={index}>{eventGroup.name}</option>
                                {/each}
                                <option value="none">{m.merge_event_group_linked_group_none()}</option>
                            </select>
                        </div>
                    </div>
                    {/if}
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" 
                    type="button" 
                    id="btnMergeEvents"
                    disabled={selectedGroups.length<2}
                    aria-disabled={selectedGroups.length<2}
                    onclick={mergeEventGroups}>{m.merge_event_group_merge_button()}</button>
            </div>
        </div>
    </div>
</div>
